module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/why/trophy-c514cee4580f5737cb23399d7f805305.svg";